export default __webpack_public_path__ + "static/media/bg.25ee129d.png";